<template lang="html">
  <section class="distribution-channel-details">
    <div v-if="isReady">
      <navigation-tabs
        class="nav-tabs-container"
        :tabs="navigationTabs"
        v-if="isDisplayNavTabs"
      />
      <router-view></router-view>
    </div>
    <transition name="loader">
      <div class="loader-wrapper" v-if="displayLoader">
        <div class="loader"></div>
      </div>
    </transition>
  </section>
</template>

<script lang="js">
  import { ROUTE_NAMES, MUTATION_NAME, TOAST_OPTIONS } from "@/static/global-variables";
  import DistributionChannelsService from "@/services/distributionChannelsService";
  import NavigationTabs from "@/components/NavigationTabs";

  export default  {
    name: "distribution-channel-details",
    components: {
      NavigationTabs
    },
    data () {
      return {
        displayLoader: false,
        isReady: false
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      isDisplayNavTabs() {
        return this.$route.name !== ROUTE_NAMES.customDisplayElementDetails &&
              this.$route.name !== ROUTE_NAMES.customDisplayElementVersionDetails;
      },
      distributionChannelDetail() {
        return this.$store.getters[MUTATION_NAME.DISTRIBUTION_CHANNEL_DETAIL] || {};
      },
      navigationTabs() {
        return [
          {
            id: "overview",
            text: this.$t("overview"),
            path: "/distribution-channels/:uuid/overview",
            name: ROUTE_NAMES.distributionChannelOverview
          },
          {
            id: "customDisplayElements",
            text: this.$t("customDisplayElements"),
            path: "/distribution-channels/:uuid/custom-display-elements",
            name: ROUTE_NAMES.distributionChannelCustomDisplayElements
          },
          {
            id: "customerDomains",
            text: this.$t("customerDomains"),
            path: "/distribution-channels/:uuid/customer-domains",
            name: ROUTE_NAMES.distributionChannelCustomerDomains
          }
        ];
      }
    },
    mounted () {
      if(this.distributionChannelDetail.uuid !== this.$route.params.uuid) {
        this.displayLoader = true;
        // get distribution channel details to display name on breadcrums
        DistributionChannelsService.distributionChannelDetails(this.$route.params.uuid)
        .catch(e => {
          this.$bvToast.toast(this.getMessageText(this.messages.ERROR_WHILE_LOADING), TOAST_OPTIONS.bottomCenter);
          console.error(e);
        })
        .finally(() => {
          this.displayLoader = false;
          this.isReady = true;
        });
      } else {
        this.isReady = true;
      }
    }
  }
</script>

<style scoped lang="scss">
  .nav-tabs-container {
    height: 3.5rem;
  }
</style>
